import { useLocation } from 'react-router';
import { useTenantSubscriptionConfig } from '@common/hooks/useTenantSubscriptionConfig';
import { APP_ROUTE } from '@router/routes';
import { getOnboardingProgressBarStyles, getProgressStyles } from './OnboardingProgressBarStyles';

export function OnboardingProgressBar(): JSX.Element {
    const location = useLocation();
    const { isTenantSubscriptionEnabled } = useTenantSubscriptionConfig();

    const getProgress = () => {
        if (location.pathname === APP_ROUTE.ONBOARDING.COMPLETED) return 100;

        const steps = isTenantSubscriptionEnabled
            ? [APP_ROUTE.ONBOARDING.SELECT_PLAN, APP_ROUTE.ONBOARDING.PLATFORMS]
            : [APP_ROUTE.ONBOARDING.PLATFORMS];

        const currentStepIndex = steps.indexOf(location.pathname as (typeof steps)[number]);

        if (currentStepIndex === -1) return 0;

        return ((currentStepIndex + 1) / (steps.length + 1)) * 100;
    };

    return (
        <div css={getOnboardingProgressBarStyles}>
            <div css={getProgressStyles(getProgress())} />
        </div>
    );
}
